var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2B2D30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#2B2D30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 19.5C29.9288 19.5 27.4154 20.2624 25.2776 21.6909C23.1398 23.1194 21.4735 25.1497 20.4896 27.5251C19.5056 29.9006 19.2482 32.5144 19.7498 35.0362C20.2514 37.5579 21.4895 39.8743 23.3076 41.6924C25.1257 43.5105 27.4421 44.7486 29.9638 45.2502C32.4856 45.7518 35.0995 45.4944 37.4749 44.5104C39.8503 43.5265 41.8807 41.8603 43.3091 39.7224C44.7376 37.5846 45.5 35.0712 45.5 32.5C45.4964 29.0533 44.1256 25.7488 41.6884 23.3116C39.2512 20.8744 35.9467 19.5036 32.5 19.5ZM32.5 43.5C30.3244 43.5 28.1977 42.8549 26.3887 41.6462C24.5798 40.4375 23.1699 38.7195 22.3373 36.7095C21.5048 34.6995 21.2869 32.4878 21.7114 30.354C22.1358 28.2202 23.1835 26.2602 24.7218 24.7218C26.2602 23.1834 28.2202 22.1358 30.354 21.7114C32.4878 21.2869 34.6995 21.5048 36.7095 22.3373C38.7195 23.1699 40.4375 24.5798 41.6462 26.3887C42.8549 28.1977 43.5 30.3244 43.5 32.5C43.4967 35.4164 42.3367 38.2123 40.2745 40.2745C38.2123 42.3367 35.4164 43.4967 32.5 43.5Z",
    fill: "#FFFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 41.5C37.4706 41.5 41.5 37.4706 41.5 32.5C41.5 27.5294 37.4706 23.5 32.5 23.5C27.5294 23.5 23.5 27.5294 23.5 32.5C23.5 37.4706 27.5294 41.5 32.5 41.5Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRecord);
export default __webpack_public_path__ + "static/media/BlackRecord.6f378145212ad84b576a812cddca3b21.svg";
export { ForwardRef as ReactComponent };